/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-alert */
/* eslint-disable camelcase */
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AuthDecorator } from '@components/auth-decorator';
import { IToken } from '@interface/token';
import { actions } from '@state/modals';
import { RootState } from '@state/store';
import { MutToTez } from '@utils/format';
import { didExpire } from '@utils/market';
import { Box, Button, Tezos } from '@versumstudios/ui';

interface IActionSwapsComponent {
  seller: any;
  swap_id: number;
  current_price: number;
  start_price: number;
  end_price: number;
  amount: number;
  amount_left: number;
  token: IToken;
  ending_time: string | null;
}

export const ActionSwapsComponent: FC<IActionSwapsComponent> = ({
  start_price,
  end_price,
  current_price,
  amount,
  amount_left,
  seller,
  swap_id,
  token,
  ending_time,
}) => {
  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.auth);
  const viewer = auth.user?.id;
  const viewerIsSeller = viewer === seller.user[0].user.id;
  const isAdvanced = start_price !== end_price;
  const isExpired = didExpire(ending_time);

  const handleCancelSwap = () => {
    if (isExpired) {
      dispatch({ type: actions.MODALS_SET_MODAL, payload: { type: 'swap-conclude', swapId: swap_id } });
    } else {
      dispatch({ type: actions.MODALS_SET_MODAL, payload: { type: 'swap-cancel', swapId: swap_id } });
    }
  };

  const handleCollectSwap = () => {
    if (isAdvanced) {
      // slippage modal only 1 quantity
      dispatch({
        type: actions.MODALS_SET_MODAL,
        payload: {
          type: 'swap-slippage',
          swapId: swap_id,
          startPrice: start_price,
          endPrice: end_price,
          amount,
          amountLeft: amount_left,
          creatorsTotal: token.creators.length,
        },
      });
    } else {
      // collect modal, multiple quantity
      dispatch({
        type: actions.MODALS_SET_MODAL,
        payload: {
          type: 'swap-collect',
          swapId: swap_id,
          swapPrice: current_price,
          swapMaxQuantity: amount_left,
          creatorsTotal: token.creators.length,
        },
      });
    }
  };

  return (
    <Box css={{ '&>*': { marginRight: '$space$4' } }}>
      {viewerIsSeller ? (
        <AuthDecorator onClick={handleCancelSwap}>
          <Button variant="market">{isExpired ? 'Complete Swap' : 'Cancel Swap'}</Button>
        </AuthDecorator>
      ) : (
        <AuthDecorator onClick={handleCollectSwap}>
          <Button variant="market">
            {`Collect for ${MutToTez(current_price)}`}
            <Tezos />
          </Button>
        </AuthDecorator>
      )}
    </Box>
  );
};
